<template>
  <div class="el-autocomplete-item">
    <div class="el-autocomplete-item__text-wrap">
      <p>{{ item.label }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AutocompleteItem',
    props: {
      item: { type: Object, required: true },
    },
  };
</script>

<style lang="scss" scoped>
  .el-autocomplete-item {
    display: flex;
    align-items: center;
    border-bottom: 1px dashed $--border-color-light;
    padding: 0.5em 0;
    line-height: 2;
    &__text-wrap {
      p {
        white-space: initial;
      }
    }
  }
</style>
